import { render } from "./PageAlterarModuloMenu.vue?vue&type=template&id=0dddda26&scoped=true"
import script from "./PageAlterarModuloMenu.vue?vue&type=script&lang=js"
export * from "./PageAlterarModuloMenu.vue?vue&type=script&lang=js"

import "./PageAlterarModuloMenu.vue?vue&type=style&index=0&id=0dddda26&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dddda26"]])

export default __exports__